import React, { Component } from 'react';
import IconTableHead from './IconTableHead';

/*
  props.title = "Basic Table"

  props.columns = [
    { key: 'id', title: '#' },
    { key: 'firstName', title: 'First Name' },
    { key: 'lastName', title: 'Last Name' },
    { key: 'product', title: 'Product' },
    { key: 'amount', title: 'Amount' },
    { key: 'deadline', title: 'Deadline' },
  ];

  props.data = [
    {
      id: 1,
      firstName: 'Herman Beck',
      lastName: 'John',
      product: 'Photoshop',
      amount: '$456.00',
      deadline: '12 May 2017',
    },
    {
      id: 2,
      firstName: 'Herman Beck',
      lastName: 'Conway',
      product: 'Flash',
      amount: '$965.00',
      deadline: '13 May 2017',
    }
  ]
  
  */

export class AdvBasicTable extends Component {
  render() {
    return (
      <div>
        {this.props.title && <h4 className='card-title'>{this.props.title}</h4>}
        <div className='table-responsive' style={this.props.style}>
          <table className='table' style={{ textAlign: 'center' }}>
            {!this.props.noHead && (
              <thead style={{ backgroundColor: 'lightgrey' }}>
                <tr>
                  {(this.props.nrCrt
                    ? [
                        {
                          key: 'nrCrt',
                          title: (
                            <IconTableHead inTable name='nr_crt' tip='Rank' />
                          ),
                        },
                      ].concat(this.props.columns)
                    : this.props.columns
                  ).map((column, index) => (
                    <th
                      key={index}
                      style={{
                        textAlign: column.leftAligned
                          ? 'left'
                          : column.rightAligned
                          ? 'right'
                          : undefined,
                        width: column.fixedWidth,
                      }}
                    >
                      {column.title}
                    </th>
                  ))}
                </tr>
              </thead>
            )}
            <tbody>
              {this.props.data.map((row, rowIndex) => (
                <tr
                  key={rowIndex}
                  className={row.className}
                  style={
                    row.bgRowColor
                      ? { backgroundColor: row.bgRowColor }
                      : undefined
                  }
                >
                  {(this.props.nrCrt
                    ? [
                        { key: 'nrCrt', title: this.props.nrCrtSymbol || '#' },
                      ].concat(this.props.columns)
                    : this.props.columns
                  ).map((column, index) =>
                    column.key === 'nrCrt' ? (
                      <td
                        key={index}
                        style={{
                          backgroundColor:
                            row.bgColumnColors && row.bgColumnColors['nrCrt'],
                        }}
                      >
                        {rowIndex + 1}
                      </td>
                    ) : (
                      <td
                        key={index}
                        style={{
                          textAlign: column.leftAligned
                            ? 'left'
                            : column.rightAligned
                            ? 'right'
                            : undefined,
                          backgroundColor:
                            row.bgColumnColors &&
                            row.bgColumnColors[column.key],
                          width: column.fixedWidth,
                        }}
                      >
                        {row[column.key]}
                      </td>
                    )
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default AdvBasicTable;
